import { render, staticRenderFns } from "./RelapseDetailView.vue?vue&type=template&id=024da118&scoped=true&"
import script from "./RelapseDetailView.vue?vue&type=script&lang=js&"
export * from "./RelapseDetailView.vue?vue&type=script&lang=js&"
import style0 from "./RelapseDetailView.vue?vue&type=style&index=0&id=024da118&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024da118",
  null
  
)

export default component.exports